import AddProject from "../components/setting/projectSettings/AddProject";

const AddProjectPage = () =>{
    return(
        <AddProject/>
    )
}
export default AddProjectPage 